@use '@/sass/variables';

.searchContainer {
}

.chipContainer {
  .chip {
    .unit {
      margin-left: variables.$spacing-extra-small;
    }

    .unit::before {
      content: '(';
    }

    .unit::after {
      content: ')';
    }
  }
}
